import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import dashborad from '../assets/image/dashborad.jpg';
import { logoutUser } from '../utils/apiService';

const Sidebar = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem('token');

    const handleLogout = async () => {
        try {
            if (token) {
                await logoutUser(token);
            }
        } catch (error) {
            console.error('Logout API error:', error);
        } finally {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            navigate('/login');
        }
    };
    return (
        <div className="wrapper position-relative">
            <div className="main-content">
                <div className="sidebarimg-banner">
                    <img src={dashborad} data-src={dashborad} alt="img" className="ls-is-cached lazyloaded" />
                </div>

                <div className="side-menu-list">
                    <NavLink to="/editprofile"  className={({ isActive }) => isActive ? "active" : ""}>
                        <span><i className="fa fa-user"></i> Profile</span>
                        <i className="fa fa-angle-right"></i>
                    </NavLink>

                     <NavLink 
                        to="/orderhistory"
                        className={({ isActive }) => isActive ? "active" : ""}
                    >
                        <span><i className="fa fa-box"></i> Order History </span>
                        <i className="fa fa-angle-right"></i>
                    </NavLink>

                     <NavLink 
                        to="/changepassword"
                        className={({ isActive }) => isActive ? "active" : ""}
                    >
                        <span><i className="fa-solid fa-key"></i> Change Password</span>
                        <i className="fa fa-angle-right"></i>
                    </NavLink>

                    <a href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                        <span><i className="fa fa-sign-out-alt"></i> Logout</span>
                        <i className="fa fa-angle-right"></i>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;